import { WhiteSpace } from 'antd-mobile'
import _ from 'lodash'
import React from 'react'
import classes from './styles.module.scss'

export default class PowerBankMapCard extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  call = (e, mobile) => {
    e.stopPropagation()
    window.location.href = `tel:${mobile}`
  };

  componentDidMount() {
    const script = document.createElement('script')
    script.src = 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js'
    script.async = true
    document.body.appendChild(script)
  }

  getDistance() {
    if (this.props.distanceParam?.unit === 'METERS' && this.distance < 1000) {
      return `${parseInt(this.distance)} m`
    } else if (this.props.distanceParam?.unit === 'KILOMETERS') {
      return `${this.distance} km`
    } else {
      return `${(this.distance / 1000).toFixed(2)} km`
    }
  }

  goToStoreDetail = (item) => {
    // eslint-disable-next-line no-undef
    if (typeof uni !== 'undefined') {
      const usp = new URLSearchParams()
      usp.append('name', this.name)
      usp.append('mobile', this.mobile)
      usp.append('address', this.props.address)
      usp.append('distance', this.getDistance())
      usp.append('lat', this.lat)
      usp.append('lng', this.lng)
      usp.append('remaining', this.props.remaining)
      usp.append('borrowing', this.props.borrowing)
      // eslint-disable-next-line no-undef
      uni.navigateTo({ url: `../store-detail/store-detail?${usp.toString()}` })
    }
  }

  render() {
    const item = this.props
    const mobile = item.contactInformation || item.tel
    const name = item.merchantName || item.name
    const distance = item.distance || _.get(item, 'distanceParam.value')
    this.lng = item.location.lng
    this.lat = item.location.lat
    this.mobile = mobile
    this.name = name
    this.distance = distance
    this.businessHours = item.businessHours
    return (
      <div className={classes.componentsPowerBankMapCard} onClick={this.goToStoreDetail}>
        <div>
          <div className={classes.merchantName}>{name}</div>
          <WhiteSpace size='xs' />
          <div className={`gray font-xs ${classes.truncate}`}>
            {item.address} {item.city && ` - ${item.city}`}
          </div>
          <WhiteSpace size='xs' />
          <p className={classes.remaining}>Available for rent: {item.remaining} </p>
          <p>Available for return: {item.borrowing}</p>
          <WhiteSpace size='xs' />
        </div>
        <div className='text-center'>
          <WhiteSpace size='xs' />
          <p className={`gray font-xs ${classes.truncate}`}>
            {this.getDistance()}
          </p>
          <WhiteSpace size='xs' />
          <img src={require('./svgs/address.svg')} />
        </div>
      </div>
    )
  }
}
